// Copyright (c) 2016 Deere & Company
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

const ValidationAndErrorMessages = ({ isValid, errorMessage, vsrMessage }) => (
    <div>

        {isValid ?
            null : (
                <span className="error-message">
                    <FormattedMessage id={errorMessage} />
                </span>
            )}
        {vsrMessage &&
            <span className="vsr-message">{`${vsrMessage}`}</span>
        }
    </div>
);

ValidationAndErrorMessages.displayName = 'ValidationAndVsrErrorMessages';
ValidationAndErrorMessages.propTypes = {
    errorMessage: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    vsrMessage: PropTypes.string,
};

export default ValidationAndErrorMessages;
